module.exports = __webpack_public_path__ + "static/media/bglogin.4c9f5a69.jpg";